import { render, staticRenderFns } from "./SelectOrganizationView.vue?vue&type=template&id=227215d8&scoped=true&"
import script from "./SelectOrganizationView.vue?vue&type=script&lang=js&"
export * from "./SelectOrganizationView.vue?vue&type=script&lang=js&"
import style0 from "./SelectOrganizationView.vue?vue&type=style&index=0&id=227215d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227215d8",
  null
  
)

export default component.exports